import axios from 'axios';
import Cookies from 'js-cookie';
import store from '@/store';
import router from '@/router';
import Vue from 'vue';

axios.defaults.withCredentials = true;

const http = (window.http = axios.create({
    baseURL: process.env.VUE_APP_API_URL + 'api/v2',
}));

let bearer = Cookies.get('access_token');

if (bearer) {
    http.defaults.headers.common.Authorization = bearer;
}

http.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8';
http.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// Handle an Unauthenticated API response, log the user out of the application.
http.interceptors.response.use(
    (resp) => resp,
    (error) => {
        if (error.response && error.response.status === 401) {
            store.commit('Auth/authLogout');
            Vue.swal('Your session has expired. Please log in again.');
            router.push('/');
        } else {
            console.error('oops', error);
        }
        return Promise.reject(error);
    }
);

export default http;
